import { render, staticRenderFns } from "./configuration-automation-portions-modal.vue?vue&type=template&id=7ab31fa5&scoped=true&"
import script from "./configuration-automation-portions-modal.ts?vue&type=script&lang=ts&"
export * from "./configuration-automation-portions-modal.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-automation-portions-modal.scss?vue&type=style&index=0&id=7ab31fa5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab31fa5",
  null
  
)

export default component.exports